module.exports = __webpack_public_path__ + "img/green-check.2a2c3be1.svg";